<template>
  <div :class="{
    'maincon':true,
    'isBlock':isBlock
  }">

    <div class="bmap-page-container">
      <el-bmap vid="bmapDemo" :bmap-manager="bmapManager" :zoom="zoom" :center="center" :events="events"
        class="bmap-demo">
        <weixing-plugin :map="map"></weixing-plugin>
        <el-bmap-polygon v-if="polygons.length && !polygondata.length" v-for="(polygon, index) in polygons"
        
          :visible="visible" :key="polygon.key" :vid="index" :ref="`polygon_${index}`" :path="polygon.path"
          :enable-editing="polygon.enableEditing" fillColor="#dedede" strokeStyle="dashed" :events="polygon.events">
        </el-bmap-polygon>

        <el-bmap-label v-for="item in pointsList" :key="item.id"  :position="[item.lng_lat.lng, item.lng_lat.lat]"
          :visible="item.visible"
          :offset="[-23,-50]"
           :is-custom="true">
          <div class="labelbox" style="color:#fff;font-size:20px;">

            <div class="labelcontent">
              <img class="iconimg" :src="item.imgurl" />
              <div class="labeltext">
                {{ item.name || '空' }}
              </div>
            </div>
            <span class="labeldown" style="color:#000"></span>
          </div>
        </el-bmap-label>


        <el-bmap-polyline v-for="polyline in polylines" :key="polyline.id" :enable-editing="polyline.enableEditing"
          :visible="polyline.visible" :strokeColor="polyline.strokeColor" :strokeStyle="polyline.strokeStyle"
          :strokeOpacity="polyline.strokeOpacity" :strokeWeight="polyline.strokeWeight" :path="polyline.path"
          :events="polyline.events"></el-bmap-polyline>
      </el-bmap>
    </div>

  </div>
</template>

<script>
import weixingPlugin from '@/components/bmap/weixingPlugin.vue'
import VueBMap from "vue-bmap-gl";
let bmapManager = new VueBMap.BMapManager();


import { pointData, polygonData, lineData } from '@/api/cityresearch'

export default {
  components: {
    weixingPlugin
  },

  props: {

    pointcate: String,
    linecate: String,
    cname: String,
    city_plate_id: {
      type: Number,
    },
    isBlock: {
      props: Boolean,
      default: false
    },
    polygondata: {

      type: Array,
      default: function () {
        return []
      }
    }
  },
  mounted() {
    this.getPointData()
    this.getLineData()
  },
  watch: {

    pointcate(v) {
      this.getPointData()
    },
    linecate() {
      this.getLineData()
    },
    shi(v) {
      this.getLineData()
      // if (v !== 0) {
      //   this.getLineData()
      // }

    },
    block(v) {
      // this.getLineData()
      if (v !== 0) {
        this.getPolygonData()
      }

    },
    city_plate_id(v) {

      // alert(v)
      // this.getPointData()



    },
    cname(v) {
      let myGeo = new BMapGL.Geocoder();
      var that = this
      myGeo.getPoint(v + '人民政府', function (point) {
        if (point) {
          that.map.centerAndZoom(point)
        } else {
          alert('您选择的地址没有解析到结果！');
        }
      }, v + '市')
      that.getPointData()
      this.setAreaLine(v)

    },




    polygondata: {
      handler(v) {
        // console.log('==data==', v)

        v.map(item => {
          this.handlerData(item.set)
        })
      },
      deep: true
    }


  },

  computed: {
    shi: {
      get() {
        return this.$store.state.shi
      },
      set(v) {
        this.$store.dispatch('changeShi', v);
      }
    },
    block: {
      get() {
        return this.$store.state.block
      },
      set(v) {
        this.$store.dispatch('changeBlock', v);
      }
    },

    currentArea: {
      get() {
        // alert(this.$store.state.currentArea)
        return this.$store.state.currentArea
      }
    }
  },
  data() {
    return {
      drwaPolygonArr: [],
      setMapMode: '地图',
      blockoverlay: {},//板块多边形对象
      visible: true,
      polylines: [],
      polygons: [

      ],
      area: '',
      pointsList: [
        {
          // id: 0,
          name: '这是标题1',
          lng_lat: {
            lat: '1',
            lng: '1'
          },
          imgurl: ''
        }
      ],
      map: {},
      bmapManager,
      geodata: "",
      events: {
        init: (o) => {
          this.map = o
          // this.map.setMapType(BMAP_EARTH_MAP);   
          let currentname = this.cname
          let myGeo = new BMapGL.Geocoder();
          // 将地址解析结果显示在地图上，并调整地图视野
          let that = this;
          myGeo.getPoint(currentname + '市人民政府', function (point) {
            if (point) {
              o.centerAndZoom(point, 10);
              // o.addOverlay(new BMapGL.Marker(point, {title: ' '}))
              that.setAreaLine(currentname)
            } else {
              alert('您选择的地址没有解析到结果！');
            }
          }, currentname + '市')

          // 将地址解析结果显示在地图上，并调整地图视野
          //  o.setViewport(points);　　
          that.getPointData()
          that.getLineData()

        },
      },
      count: 1,
      center: [0, 0],
      zoom: 12
    };
  },
  methods: {





    handleImg(data) {
      const res = data.map(item => {
        item.imgurl = require('@/assets/icon/jiaotong' + item.type + '.png')
        return item
      })
      return res
    },

    //获取点数据
    getPointData() {
      const params = {
        city_plate_id: this.shi,
        type: this.pointcate
      }

      if (this.city_plate_id) {
        pointData(params).then(res => {
          // console.log('===', res)
          this.pointsList = this.handleImg(res.data)
        })
      }
    },

    getLineData() {

      const params = {
        // city_plate_id: this.city_plate_id,
        city_plate_id: this.shi,
        type: this.linecate
      }


      if (this.shi) {
        lineData(params).then(res => {



          const lineArr = res.data
          
          this.polylines  = []
          const polylineArr = lineArr.map(line => {
            const LinePointArr = JSON.parse(line.set)
            // console.log('LinePointArr', LinePointArr)
            let path = []
            LinePointArr.map(item => {
              path.push([item.lng, item.lat])
            })
            return {
              id:line.id,
              path: path,
              visible: true,
              strokeColor: line.color,	//String	//线条颜色，使用16进制颜色代码赋值。默认值为#006600
              strokeOpacity: Number(line.transparency),	//Number	线条透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
              strokeWeight: Number(line.width),	//Number	线条宽度，单位：像素
              strokeStyle: line.strokestyle	//Number	线条宽度，单位：像素
            }
            // alert(line.strokestyle)

          })

          // console.log('=====',polylineArr)
          this.polylines = polylineArr


        })
      }
    },

    // 处理数据
    handlerData(data) {
      const dataArr = JSON.parse(data) // 获取地图数据数组
      dataArr.map(obj => {
        this.drawPloygonByBD(obj)
      })
    },




    // 获取手动画 数据库api数据 画多变形
    drawPloygonByBD(obj) {
      // this.map.clearOverlays()// 添加覆盖物
      var that = this
      this.drwaPolygonArr.map(ply => {
        // console.log(' this.ply', ply)
            that.map.removeOverlay(ply)
      })
      


      var ply = new BMapGL.Polygon(obj.multipoint, {
        strokeWeight: 2,
        // strokeColor: obj.strokecolor
        strokeStyle: 'dashed',
        fillColor: '#dedede',
        strokeColor: '#000000'


      }) // 建立多边形覆盖物
      this.blockoverlay = ply
      
      
      this.drwaPolygonArr.push(ply)
      
      // console.log(' this.drwaPolygonArr', this.drwaPolygonArr)

      

      this.map.addOverlay(ply) // 添加覆盖物
      // this.map.setViewport(ply.getPath()) // 调整视野
    },






    toChangeLocation() {

    },

    changeCenter() {
      let o = this.bmapManager.getMap()
      // console.log(o)
    },

    getPolygonData() {
      // alert(this.currentArea)
      let currentAreaid
      if (this.isBlock) {
        currentAreaid = this.block
      } else {
        currentAreaid = this.currentArea
      }
      // alert('block='+currentAreaid)

      const params = {
        city_plate_id: currentAreaid,
        type: 10
      }

      polygonData(params).then(res => {
        const polygondata = res.data
        polygondata.map(item => {
          this.handlerData(item.set)
        })

      })
    },


    setAreaLine(cname) {
      if (cname) {

        var bdary = new BMapGL.Boundary();
        var that = this;
        bdary.get(cname, function (rs) {
          //这里是用户自己的函数。 

          that.drwaPolygonArr.map(ply => {
            that.map.removeOverlay(ply)
          })
          that.polygons = []
          // alert()
          if (that.isBlock || rs.boundaries.length === 0) { //自定义区域画多变形
            // if (isBlock)
            that.getPolygonData()
          } else {
            const newbounderies = rs.boundaries.map(item => {
              let single = item.split(';');
              let newItem = single.map(v => {
                return v.split(',')
              })
              const object = {
                path: newItem,

              }
              

              return object;
            })

            that.polygons = newbounderies;
            // that.map.setViewport(newbounderies) // 调整视野
          }

        });
      }

    }




  },


};
</script> 
<style lang="scss" scoped>
.maincon {
  position: relative;
  height: calc(100vh - 220px);
}
// .isBlock{
//   height: calc(100vh - 20px);
// }

.contrl {
  position: absolute;
  ;
  right: 0;
  top: 0;
  width: 200px;
  background: #fff;
  height: calc(100vh - 220px);
  z-index: 9999
}

.bmap-demo {
  height: calc(100vh - 140px);
}

.labelbox {
  display: flex;
  flex-direction: column;
  justify-content: center;


  align-items: flex-start;
  border-radius: 5px;

  .labelcontent {
    border: solid 1px #fff;
    background: #fff;
    border-radius: 4px;
    color: #333;
    font-size: 14px;
    padding: 4px;
    display: flex;
    flex-direction: row;
    padding: 5px 10px;
    justify-content: space-between;
    align-items: center;

    .iconimg {
      height: 30px;
      width: 30px;
    }

    .labeltext {
      margin-left: 10px;
    }

    // mar
  }

  .labeldown {
    margin-left:15px;
    width: 0;
    height: 0;
    border-top: 10px solid #fff;
    border-right: 10px solid transparent;
    border-left: 10px solid transparent;

  }
}
</style>